import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/** GET /api/v1/capital のレスポンスにおける個別アセット残高 */
export const balanceSchema = z.object({
  /** 利用可能な残高 */
  available: decimalSchema,
  /** オープンオーダー等でロックされている残高 */
  locked: decimalSchema,
  /** ステーキング中の残高 */
  staked: decimalSchema,
})

/** GET /api/v1/capital のレスポンス: シンボル毎の残高マップ */
export const balancesResponseSchema = z.record(z.string(), balanceSchema)

export type Balance = z.infer<typeof balanceSchema>
export type BalancesResponse = z.infer<typeof balancesResponseSchema>
